import i18n from "../../i18n";
import React, { useMemo } from "react";
import { Table, Text, Badge } from "@mantine/core";
import moment from "moment";
import { formatStaffLabel } from "../../data/mcaEntities";

const ACTION_LABELS = {
  SUBMITTED: "Submitted",
  RESUBMITTED: "Resubmitted",
  STEP_APPROVED: "Step Approved",
  STEP_REJECTED: "Step Rejected",
  STEP_ADVANCED: "Step Advanced",
  APPLIED: "Applied",
  TERMINATED: "Terminated",
  CANCELLED: "Cancelled",
  EXPIRED: "Expired",
  PAYLOAD_UPDATED: "Payload Updated",
};

const formatActionLabel = (action) =>
  ACTION_LABELS[action] ?? action?.replace(/_/g, " ") ?? "—";

const formatDetails = (log) => {
  const parts = [];
  if (log.round) parts.push(`Round ${log.round}`);
  if (log.stepName) parts.push(log.stepName);
  if (log.comment) parts.push(log.comment);
  return parts.length ? parts.join(" · ") : "—";
};

const McaAuditLogTable = ({ logs = [] }) => {
  const sortedLogs = useMemo(
    () =>
      [...logs].sort(
        (a, b) => new Date(b.at ?? 0).getTime() - new Date(a.at ?? 0).getTime()
      ),
    [logs]
  );

  if (!sortedLogs.length) {
    return (
      <Text color="dimmed" size="sm">
        No audit log entries.
      </Text>
    );
  }

  return (
    <Table striped highlightOnHover withBorder verticalSpacing="sm">
      <thead>
        <tr>
          <th>{i18n.t("Date Time")}</th>
          <th>{i18n.t("Type")}</th>
          <th>{i18n.t("Details")}</th>
          <th>By</th>
        </tr>
      </thead>
      <tbody>
        {sortedLogs.map((log, idx) => (
          <tr key={idx}>
            <td>
              <Text size="sm">
                {log.at
                  ? moment(log.at).format("YYYY-MM-DD HH:mm")
                  : "—"}
              </Text>
            </td>
            <td>
              <Badge size="sm" variant="outline" color="gray">
                {formatActionLabel(log.action)}
              </Badge>
            </td>
            <td>
              <Text size="sm" lineClamp={3}>
                {formatDetails(log)}
              </Text>
            </td>
            <td>
              <Text size="sm">
                {log.by ? formatStaffLabel(log.by) ?? "—" : "System"}
              </Text>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default McaAuditLogTable;
